import { TemplateNodeSchema } from '@ulysses-inc/harami_api_client'

/**
 * セクション配下の全ノードを再帰的に取得する
 *
 * @param sectionNode セクションノード
 * @param templateNodes すべてのテンプレートノード
 * @returns セクション配下の全ノード
 */
export const getSectionChildNodes = (
  sectionNode: TemplateNodeSchema,
  templateNodes: Record<number, TemplateNodeSchema>,
): TemplateNodeSchema[] => {
  const childNodes: TemplateNodeSchema[] = []

  const collectChildNodes = (nodeIds: number[]) => {
    for (const nodeId of nodeIds) {
      const node = templateNodes[nodeId]
      if (!node) continue

      childNodes.push(node)

      // 全ノードタイプの子ノードを再帰的に収集
      // ※ 条件分岐(Logic)はQuestion(トリガー質問)の子として格納されるため、
      //    Questionノードも含めて全タイプを探索する必要がある
      if (node.nodes && node.nodes.length > 0) {
        collectChildNodes(node.nodes)
      }
    }
  }

  if (sectionNode.nodes && sectionNode.nodes.length > 0) {
    collectChildNodes(sectionNode.nodes)
  }

  return childNodes
}
